<template>
  <icon-label
    :label="$t('payment.status.' + status)"
    :icon="icon"
  />
</template>

<script>
import iconLabel from '../../components/IconLabel.vue'

export default {
  components: {
    'icon-label': iconLabel
  },
  props: {
    status: {
      type: String,
      default: ''
    }
  },
  computed: {
    icon () {
      switch (this.status) {
        case 'new':
          return this.$publicPath + 'img/payments/add.svg'
        case 'in_progress':
          return this.$publicPath + 'img/payments/infinity.png'
        case 'completed':
          return this.$publicPath + 'img/payments/ok.svg'
        case 'rejected':
          return this.$publicPath + 'img/payments/x.svg'
        default:
          return ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
